import Page404 from "./404";
import About01 from "./About01";
import About02 from "./About02";
import Blog from "./Blog";

import BlogDetails from "./BlogDetails";

import Collection from "./new_Collection";
import CommingSoon from "./CommingSoon";

import Contact from "./Contact";

import Faq01 from "./Faq01";
import Faq02 from "./Faq02";


import Home01 from "./Home01";
import Home02 from "./Home02";
import Home03 from "./Home03";
import ItemDetails from "./ItemDetails";

import Login from "./Login";
import OurTeam from "./OurTeam";

import RoadMap01 from "./RoadMap01";
import RoadMap02 from "./RoadMap02";
import RoadMap03 from "./RoadMap03";
import SignUp from "./SignUp";
import Testimonials from "./Testimonials";

import ProtectedRoute from "../middleware/ProtectedRoute";
import PublicRoute from "../middleware/PublicRoute";
import PaymentPage from "./PaymentPage";
import Selles from "./salles/selles";
import Successful from "./Successful";
import Test from "./test";
import NewSall from "./new_sall/sall";
import CompletePurchase from "./new_sall/CompletePurchase";
import Password from "./password/password";
import ResetPassword from "./password/reset_password";
import CryptomusCallback from "./new_sall/payments/CryptomusCallback";
import PayopCallback from "./new_sall/payments/PayopCallback";
// import Selles from "./salles/selles";
// import FormSellesData from "./salles/formSallesData";


const routes = [
  { path: '/', component: <Home02/>},
  // { path: '/sells', component: <ProtectedRoute element={<Selles />} />},

  { path: '/about-us', component: <About01 />},
  { path: '/about-v2', component: <About02 />},

  { path: '/roadmap-v1', component: <RoadMap01 />},
  { path: '/roadmap-v2', component: <RoadMap02 />},
  { path: '/roadmap-v3', component: <RoadMap03 />},

  { path: '/signin', component: <PublicRoute element={<Login />} />},
  { path: '/signup', component: <PublicRoute element={<SignUp />} />},
  { path: '/forgot-password', component: <PublicRoute element={<Password />} />},
  { path: '/reset-password/:token', component: <PublicRoute element={<ResetPassword />} />},


  { path: '/faq-v1', component: <Faq01 />},
  { path: '/faq-v2', component: <Faq02 />},
  { path: '/our-team', component: <OurTeam />},
  { path: '/collection', component: <Collection />},
  { path: '/testimonial', component: <Testimonials />},
  { path: '/comming-soon', component: <CommingSoon />},
  { path: '/page-404', component: <Page404 />},
  { path: '/test', component: <Test />},

  { path: '/blog', component: <Blog />},
  { path: '/blog-details', component: <BlogDetails />},
  { path: '/contact', component: <Contact />},
  { path: '/item-details/:id', component: <ProtectedRoute element={<ItemDetails />} />},
  { path: '/payment-page/:id', component: <ProtectedRoute element={<PaymentPage />} />},
  { path: '/collection/Offer/:id', component: <ProtectedRoute element={<NewSall/>} />},
  // { path: '/selles', component: <ProtectedRoute element={<Selles />} />},
  // { path: '/formSellesData', component: <ProtectedRoute element={<FormSellesData />} />},
  { path: '/successful/:id/:type', component: <ProtectedRoute element={<Successful />} />},
  { path: '/complete-purchase/:id', component: <ProtectedRoute element={<CompletePurchase />} />},
  { path: '/cryptomus-callback', component: <CryptomusCallback />},
  { path: '/payment/callback/cryptomus', component: <CryptomusCallback />},
  { path: '/payop-callback', component: <PayopCallback />},
]

export default routes;